import React from 'react';
import cx from 'classnames';

import Accordion from '~/components/accordion/accordion';
import Modal from '~/components/modals/modal';
import LawnPlanFaqModalContent from '~/components/modals/plan-faqs/lawn-plan-faq-content';

import styles from '~/components/modals/plan-faqs/plan-faqs-modal.module.scss';

const PlanFAQsModal = ({
  onClose,
  isOpen,
  initialQuestion,
  faqContent = LawnPlanFaqModalContent,
}) => (
  <Modal onClose={onClose} isOpen={isOpen} className={styles.planFaqsWrapper}>
    <Content initialQuestion={initialQuestion} faqContent={faqContent} />
  </Modal>
);

const Content = ({ initialQuestion = '', faqContent }) => (
  <div className={styles.planFaqsModal}>
    <h2 className={styles.planFaqsHeader}>We’ve got answers!</h2>
    <div className={styles.planFaqsContainer}>
      {faqContent?.map((section, i) => (
        <div key={section.headerText} className={styles.sectionContainer}>
          <div className={styles.sectionHeaderContainer}>
            {section.icon && (
              <img
                alt={section.altText}
                src={section.icon}
                height={30}
                width={30}
              />
            )}
            <p>{section.headerText}</p>
          </div>
          <div
            className={cx(styles.accordionContainer, {
              [styles.lastAccordion]: faqContent.length === i + 1,
            })}
          >
            {section.questions.map((q) => (
              <Accordion
                buttonClassName={styles.planFaqAccordionButton}
                buttonContent={
                  <span className={styles.planFaqsQuestion}>{q.question}</span>
                }
                key={q.question}
                isOpen={q.question === initialQuestion}
              >
                <div className={styles.planFaqsAnswer}>{q.answer}</div>
              </Accordion>
            ))}
          </div>
        </div>
      ))}
    </div>
  </div>
);

export default PlanFAQsModal;
